module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PviJ1N/images/e9781439632499_cover.jpg?1684514594360",
      "alt": "This image is the cover for the book West Chester, Postcard History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("West Chester, Postcard History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("West Chester has grown from the sleepy village originally known as Turk�s Head in the 1700s to a bustling community hosting West Chester University, a thriving educational institution. The selection of West Chester as the seat of Chester County�s government in 1785 led citizens to march on the town �armed with a field-piece, a barrel of whiskey, and other warlike munitions.� Architect Thomas U. Walter, who designed the U.S. Capitol, was responsible for several classic town buildings.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bruce Edward Mowday\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("West Chester features postcards from Bruce Edward Mowday�s personal collection. He is the author of three additional books, Along the Brandywine River, Coatesville, and Downingtown. Mowday worked for a West Chester newspaper for more than twenty years. A member of numerous historical organizations and a board member of the Chester County Historical Society, he has written histories of Fort Delaware in the Civil War and the Revolutionary War Battle of Brandywine.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0